import { gql } from '@apollo/client';

export default gql`
  query GetArticle($id: ID! = "", $slug: String! = "") {
    newsGroup(documentId: $id) {
      news_items(filters: { slug: { eq: $slug } }) {
        slug
        title
        author
        date
        newsContent_ck
        disableBookmarking
        newsAuthor {
          name
          email
          role
          company
          linkedinUrl
          twitterUrl
        }
        image {
          url
        }
        desktopImage {
          url
        }
        mobileImage {
          url
        }
        carouselPosition
        image_carousel {
          carouselItems(pagination: { limit: 30 }) {
            image {
              url
            }
          }
        }
        keywords {
          keyword
        }
        bookmarkLinks {
          label
          externalUrl
        }
      }
    }
  }
`;
